import { validate } from 'sha-el-design/lib';

export const questionSchema = validate(validate.Object({
  name: validate.Text().required('Name is required'),
  questionType: validate.Text().required('QuestionType is required'),
  description: validate.Text().required('Description is required'),
  options: validate.Array(validate.Object({
    option: validate.Text(),
  })),
}));

// The list used to filter addedBy_Id to the logged-in admin, so each admin saw
// only the questions they created themselves -- on a master screen that is a
// trap, not a feature (the dropdown feeding questionnaires keeps its own
// filter). usedInQuestionnaire drives the In-use badge and read-only state.
export const questionListQuery = `
  query allQuestions($after: String!, $name: String){
    allQuestions(first: 20, after: $after, name_Icontains:$name) {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          id
          name
          description
          options
          questionType
          usedInQuestionnaire
        }
      }
    }
  }
`;

export const questionDetailsQuery = `query question($id: ID!){
  question(id: $id) {
    id
    name
    description
    questionType
    options
    usedInQuestionnaire
  }
}`;

export const questionEditQuery = `
query QuestionDetailsQuery($id: ID!) {
  question(id: $id) {
    id
    name
    description
    questionType
    options
  }
}
`;

// Used by the questionnaire builder's Questions picker (sole consumer).
// The addedBy_Id filter is gone: it scoped the picker to questions the current
// admin created (and to NOTHING while user$ was still resolving), so another
// admin's questions could never be added to a questionnaire. `first: 100` is
// explicit because graphene-django's RELAY_CONNECTION_MAX_LIMIT silently
// capped the unbounded query at 100 anyway.
export const questionDropdownQuery = `
  query allQuestions($name: String){
    allQuestions(first: 100, name_Icontains:$name) {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          id
          name
          description
          options
          questionType
        }
      }
    }
  }
`;

export const mutation = `mutation CreateQuestion($input: QuestionMutationInput!) {
  createQuestion(input: $input) {
    question {
      id
    }
    errors {
      field
      messages
    }
  }
}`;
